import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0e433b93 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _83dfe29a = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _cbd4fa14 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _6e9c9ab8 = () => interopDefault(import('../pages/account/history.vue' /* webpackChunkName: "pages/account/history" */))
const _a658681e = () => interopDefault(import('../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _50c27436 = () => interopDefault(import('../pages/account/pay-orders.vue' /* webpackChunkName: "pages/account/pay-orders" */))
const _8012b18e = () => interopDefault(import('../pages/account/payments.vue' /* webpackChunkName: "pages/account/payments" */))
const _552e33aa = () => interopDefault(import('../pages/account/saved.vue' /* webpackChunkName: "pages/account/saved" */))
const _410145a8 = () => interopDefault(import('../pages/account/users.vue' /* webpackChunkName: "pages/account/users" */))
const _50a743e0 = () => interopDefault(import('../pages/backyard-wellness-space.vue' /* webpackChunkName: "pages/backyard-wellness-space" */))
const _999675e2 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _2afeb844 = () => interopDefault(import('../pages/blog-draft-preview/index.vue' /* webpackChunkName: "pages/blog-draft-preview/index" */))
const _e08117ec = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _2b2fe1e2 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _e64111b4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _49964374 = () => interopDefault(import('../pages/dealer/index.vue' /* webpackChunkName: "pages/dealer/index" */))
const _554ad60d = () => interopDefault(import('../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _ed92f0ce = () => interopDefault(import('../pages/indoor-saunas.vue' /* webpackChunkName: "pages/indoor-saunas" */))
const _269481af = () => interopDefault(import('../pages/legacy-blog/index.vue' /* webpackChunkName: "pages/legacy-blog/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _07ac5ff2 = () => interopDefault(import('../pages/order-pay/index.vue' /* webpackChunkName: "pages/order-pay/index" */))
const _3ec9a034 = () => interopDefault(import('../pages/outdoor-saunas.vue' /* webpackChunkName: "pages/outdoor-saunas" */))
const _91935f00 = () => interopDefault(import('../pages/outdoor-saunas-built-to-last.vue' /* webpackChunkName: "pages/outdoor-saunas-built-to-last" */))
const _1b596bfe = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _06e1891d = () => interopDefault(import('../pages/product-lead-times.vue' /* webpackChunkName: "pages/product-lead-times" */))
const _6f53e0da = () => interopDefault(import('../pages/retailer.vue' /* webpackChunkName: "pages/retailer" */))
const _763ddb8c = () => interopDefault(import('../pages/sauna-cold-plunge-contrast-therapy.vue' /* webpackChunkName: "pages/sauna-cold-plunge-contrast-therapy" */))
const _86a77a4a = () => interopDefault(import('../pages/sauna-heater-size-calculator.vue' /* webpackChunkName: "pages/sauna-heater-size-calculator" */))
const _3d268e12 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _1b9b8b70 = () => interopDefault(import('../pages/warranty-registration.vue' /* webpackChunkName: "pages/warranty-registration" */))
const _983549a2 = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _64302ff0 = () => interopDefault(import('../pages/dealer/changelog.vue' /* webpackChunkName: "pages/dealer/changelog" */))
const _5a0efbdf = () => interopDefault(import('../pages/dealer/downloads.vue' /* webpackChunkName: "pages/dealer/downloads" */))
const _da3dcec0 = () => interopDefault(import('../pages/dealer/information.vue' /* webpackChunkName: "pages/dealer/information" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f16b195e = () => interopDefault(import('../pages/arinv/_id.vue' /* webpackChunkName: "pages/arinv/_id" */))
const _2e6bfad4 = () => interopDefault(import('../pages/blog-draft-preview/_slug.vue' /* webpackChunkName: "pages/blog-draft-preview/_slug" */))
const _9d03b872 = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _007c6ded = () => interopDefault(import('../pages/catalog/_category.vue' /* webpackChunkName: "pages/catalog/_category" */))
const _3362ffdb = () => interopDefault(import('../pages/checkout/_id.vue' /* webpackChunkName: "pages/checkout/_id" */))
const _24dde067 = () => interopDefault(import('../pages/legacy-blog/_slug.vue' /* webpackChunkName: "pages/legacy-blog/_slug" */))
const _0b9fa9c9 = () => interopDefault(import('../pages/order-pay/_autoid.vue' /* webpackChunkName: "pages/order-pay/_autoid" */))
const _57b09cf2 = () => interopDefault(import('../pages/proposal/_id.vue' /* webpackChunkName: "pages/proposal/_id" */))
const _a3b5fa9a = () => interopDefault(import('../pages/reset/_hash.vue' /* webpackChunkName: "pages/reset/_hash" */))
const _0216d8db = () => interopDefault(import('../pages/product/_id/_slug.vue' /* webpackChunkName: "pages/product/_id/_slug" */))
const _2c447510 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'link--active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _0e433b93,
    name: "about"
  }, {
    path: "/account",
    component: _83dfe29a,
    children: [{
      path: "",
      component: _cbd4fa14,
      name: "account"
    }, {
      path: "history",
      component: _6e9c9ab8,
      name: "account-history"
    }, {
      path: "orders",
      component: _a658681e,
      name: "account-orders"
    }, {
      path: "pay-orders",
      component: _50c27436,
      name: "account-pay-orders"
    }, {
      path: "payments",
      component: _8012b18e,
      name: "account-payments"
    }, {
      path: "saved",
      component: _552e33aa,
      name: "account-saved"
    }, {
      path: "users",
      component: _410145a8,
      name: "account-users"
    }]
  }, {
    path: "/backyard-wellness-space",
    component: _50a743e0,
    name: "backyard-wellness-space"
  }, {
    path: "/blog",
    component: _999675e2,
    name: "blog"
  }, {
    path: "/blog-draft-preview",
    component: _2afeb844,
    name: "blog-draft-preview"
  }, {
    path: "/cart",
    component: _e08117ec,
    name: "cart"
  }, {
    path: "/catalog",
    component: _2b2fe1e2,
    name: "catalog"
  }, {
    path: "/checkout",
    component: _168b6cb3,
    name: "checkout"
  }, {
    path: "/contact",
    component: _e64111b4,
    name: "contact"
  }, {
    path: "/dealer",
    component: _49964374,
    name: "dealer"
  }, {
    path: "/forgot",
    component: _554ad60d,
    name: "forgot"
  }, {
    path: "/indoor-saunas",
    component: _ed92f0ce,
    name: "indoor-saunas"
  }, {
    path: "/legacy-blog",
    component: _269481af,
    name: "legacy-blog"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/order-pay",
    component: _07ac5ff2,
    name: "order-pay"
  }, {
    path: "/outdoor-saunas",
    component: _3ec9a034,
    name: "outdoor-saunas"
  }, {
    path: "/outdoor-saunas-built-to-last",
    component: _91935f00,
    name: "outdoor-saunas-built-to-last"
  }, {
    path: "/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy"
  }, {
    path: "/product-lead-times",
    component: _06e1891d,
    name: "product-lead-times"
  }, {
    path: "/retailer",
    component: _6f53e0da,
    name: "retailer"
  }, {
    path: "/sauna-cold-plunge-contrast-therapy",
    component: _763ddb8c,
    name: "sauna-cold-plunge-contrast-therapy"
  }, {
    path: "/sauna-heater-size-calculator",
    component: _86a77a4a,
    name: "sauna-heater-size-calculator"
  }, {
    path: "/search",
    component: _3d268e12,
    name: "search"
  }, {
    path: "/warranty-registration",
    component: _1b9b8b70,
    name: "warranty-registration"
  }, {
    path: "/wishlist",
    component: _983549a2,
    name: "wishlist"
  }, {
    path: "/dealer/changelog",
    component: _64302ff0,
    name: "dealer-changelog"
  }, {
    path: "/dealer/downloads",
    component: _5a0efbdf,
    name: "dealer-downloads"
  }, {
    path: "/dealer/information",
    component: _da3dcec0,
    name: "dealer-information"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/arinv/:id?",
    component: _f16b195e,
    name: "arinv-id"
  }, {
    path: "/blog-draft-preview/:slug",
    component: _2e6bfad4,
    name: "blog-draft-preview-slug"
  }, {
    path: "/blog/:slug",
    component: _9d03b872,
    name: "blog-slug"
  }, {
    path: "/catalog/:category",
    component: _007c6ded,
    name: "catalog-category"
  }, {
    path: "/checkout/:id",
    component: _3362ffdb,
    name: "checkout-id"
  }, {
    path: "/legacy-blog/:slug?",
    component: _24dde067,
    name: "legacy-blog-slug"
  }, {
    path: "/order-pay/:autoid?",
    component: _0b9fa9c9,
    name: "order-pay-autoid"
  }, {
    path: "/proposal/:id?",
    component: _57b09cf2,
    name: "proposal-id"
  }, {
    path: "/reset/:hash?",
    component: _a3b5fa9a,
    name: "reset-hash"
  }, {
    path: "/product/:id?/:slug?",
    component: _0216d8db,
    name: "product-id-slug"
  }, {
    path: "/:slug",
    component: _2c447510,
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
